import request from '@/utils/request'

// banner
export function queryAllBanners(data) {
  const params = {
      header: {
      },
      content: data
  }
  return request({
      url: '/fjtec-public-svc/banner/queryAll',
      method: 'post',
      data: params
  })
}

